export default __webpack_public_path__ + "static/media/face3.c2ccfa6f.jpg";